<!-- ################################# -->
<!-- TEMPLATE -->
<!-- ################################# -->
<template>
	<div class="booking-box event-box mdc-card" v-if="show">
		<!-- BOX -->
		<div v-show="showSection" class="event-box__container booking-box__container mdc-card__horizontal-block">
			<div class="event-box__color-type" :style="'background-color: '+color"></div>
			<div class="event-box__content booking-box__content">
				<!-- Image -->
				<a :href="'/properties/' + booking.property.propertyId" class="mq-md-hidden event-box__image" :class="{'event-box__image--none': booking.property.mainImage === '' || booking.property.mainImage === null || booking.property.mainImage === undefined}" v-bind:style="{backgroundImage: 'url(\''+ s3url(booking.property.mainImage, 'small') +'\')'}" @click="$router.push('/properties/' + booking.property.propertyId)">
				</a>

				<!-- Info -->
				<div class="event-box__info booking-box__info">
          <a href="#" class="event-box__dismiss-btn" style="margin-right:-20px;margin-top:-10px;border-color: #FF7863" @click.prevent="archiveThis">
            <i class="ico ico-delete" style="color:#FF7863"></i>
          </a>
					<!-- <span class="event-box__title">{{isMatch ? 'New match!' : 'New Property!'}}</span>
					<a href="#" v-if="showDismiss" class="mq-sm-hide event-box__dismiss-text" @click.prevent="dismiss(dismissId)">
						<span>Dismiss</span>
					</a>
					<a href="#" v-if="showDismiss" class="mq-sm-show event-box__dismiss-btn" @click.prevent="dismiss(dismissId)">
						<i class="ico ico-delete"></i>
					</a> -->
          <div class="booking-box__info__wrapper">
            <a :href="'/properties/'+booking.propertyId">{{ booking.property.address.buildingNumber }} {{ booking.property.address.street }} </a>, {{ $parent.niceDate(booking.date_suggested) }},
            <a v-if="booking.profileExtra.applicantId" :href="'/applicants/'+booking.profileExtra.applicantId">{{ booking.profileExtra.name }}</a>
            <span v-else>{{ booking.profileExtra.name }}</span>
          </div>

					<!--<br><span class="event-box__name" @click="$router.push('/properties/' + booking.property.propertyId)">{{propertyAddress(booking.property)}}</span>-->
						<!-- <span class="mq-md-hidden event-box__status" v-if="isMatch">{{matches}} new {{matches === 1 ? 'match' : 'matches'}}</span> -->
<!--						<span class="mq-md-hidden event-box__status">{{ propertyStatus }}</span>
					<br><span class="event-box__details">{{ price }}</span><span class="mq-md-hidden event-box__details-beds">&nbsp;&nbsp;{{ bedsAndType }}</span>-->
					 <!-- <span class="mq-md-show event-box__status" v-if="isMatch">{{matches}} new {{matches === 1 ? 'match' : 'matches'}}</span><span v-else class="mq-md-show event-box__status">{{ propertyStatus }}</span> -->
				</div>
			</div>
      <div class="booking-box__btn-wrapper">
      <div class="" v-if="booking.status == 'cancelled'">
        <div class="">
          <button class="mdc-button mdc-button--raised" v-if='booking.nextaction == "inviter"' v-on:click="$parent.bookReopen(booking.trackId,booking.inviterId)">Suggest another time</button>
        </div>
      </div>
      <div class="" v-else-if="isPending">
        <div class="" v-if="booking.nextaction == 'inviter'">
          <button class="mdc-button mdc-button--raised" v-on:click="$parent.confirmPending(booking.trackId,booking.inviterId)" style="margin-bottom:7px">Confirm</button>
          <button class="mdc-button mdc-button--raised" style="margin-bottom:7px" v-on:click="$parent.suggestPending(booking.trackId,booking.inviterId)">Suggest another time</button>
        </div>
        <div class="" v-else>
          Viewing request pending - awaiting applicant confirmation
        </div>

        <button class="mdc-button mdc-button--raised" style="background-color:#FF4D58" v-on:click="$parent.bookCancel(booking.trackId,booking.inviterId)">Cancel</button>
      </div>
      <div class="" v-else-if="!isPending">
        <button class="mdc-button mdc-button--raised" style="background-color:#FF4D58" v-on:click="$parent.bookCancel(booking.trackId,booking.inviterId)">Cancel</button>
      </div>
    </div>
    <div class="event-box__more-btn__border-mobile"></div>

		</div>
	</div>
</template>


<!-- ################################# -->
<!-- SCRIPT -->
<!-- ################################# -->
<script>
import utils from '@/libs/mixins.js';
import api from '@/libs/api.js';

export default {
	props: {
		booking: [Object, Array],
    isPending: Boolean,
		arrayIndex: Number,
    color: String
	},
	data: function() {
		return {
			show: true,
			showSection: true
		}
	},
	mixins: [utils],
  created: async function() {
    this.show = this.booking.archived ? false : true;
  },
	 computed: {
		 propertyStatus: function() {
       if (!this.booking.property.status || !this.booking.property.serviceType || !this.$store.state.propertyLists || !this.$store.state.propertyLists.propertyStatus || !this.$store.state.propertyLists.propertyStatus[this.booking.property.serviceType] || !this.$store.state.propertyLists.propertyStatus[this.booking.property.serviceType][this.booking.property.status]) {
         return '';
       }
 			 return this.$store.state.propertyLists.propertyStatus[this.booking.property.serviceType][this.booking.property.status];
 		},
 		price: function() {
 			if (this.booking.property.serviceType === 'sales') {
 			   return this.formatCurrency(this.booking.property.price);
 			} else {
 				 return this.formatCurrency(this.booking.property.price) + ' ' + this.booking.property.rentFrequency;
 			}
 		},
 		bedsAndType: function() {
 			var summary = ''
 		  if(this.booking.property.bedrooms == 0) {
 			  summary += 'Studio';
 		  } else {
 				summary += ' ' + this.booking.property.bedrooms + ' bedroom';
 			}
 			if (this.booking.property.bedrooms !== 0) {
 				summary += ' ' + this.propertyTypeName(this.booking.property.type).toLowerCase();
 			}
 		  return summary;
 	  }
 	},
  methods: {
    archiveThis: async function() {
      const archived = await api({endpoint: this.config.services.booking, path: '/archive/'+this.booking.trackId, method: 'GET'});
      if (archived) {
        this.show = this.booking.archived ? true : false;
      }
    }
	}
}
</script>

<style>
@media (max-width: 479px) {
}
</style>



// WEBPACK FOOTER //
// src/components/BookingBox.vue